import classNames from "classnames";
import ModalWrapper from "../modalWrapper";
import styles from "./style.module.scss";

interface CustomModalProps {
  children: any;
  onClose: () => void;
}

const CustomModal = ({ children, onClose }: CustomModalProps) => {
  return (
    <ModalWrapper>
      <div className={classNames(styles.contentContainer)}>{children}</div>
    </ModalWrapper>
  );
};

export default CustomModal;
